import ItemManager from "@/components/admin/ItemManager";

export default function GalleryManager() {
  return (
    <ItemManager
      collection="gallery"
      title="Gallery"
      subtitle="Photos shown in the public gallery — winners, events, press and founder moments."
      testidPrefix="gallery"
      fields={[
        { name: "title", label: "Title", type: "text" },
        { name: "category", label: "Category (e.g. Kids, Winners, Press)", type: "text" },
        { name: "image", label: "Photo", type: "image" },
      ]}
      cardTitle={(i) => i.title}
      cardSubtitle={(i) => i.category}
    />
  );
}
